import { Chip } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSearchParam } from "lib/@hooks/use-search-param"
import Iconify from "minimals-template/components/Iconify"
import { skillMapScheduleAssignments } from "routes/skill-mapper/controller/skill-map-schedule-assignments"
import { TradeNoSkillsLabel } from "../trade-no-skills-label"
import { countAssignmentsByKind, describeAssignmentCounts } from "./describe-assignment-counts"

/**
 * On the skill routing view (FIQ-2457): what a trade receives through schedule
 * assignments, e.g. "2 folders, 12 schedules assigned". Clicking it opens the Schedule
 * assignments view. "No skills" only shows when the trade has neither skills nor
 * assignments (naming any conditional rules that send it work). Plugged into
 * SkillMapTradeRowExtra behind the flag (the query is gated on its demand); the row is the
 * bound target.
 */
export function TradeAssignmentSummary() {
    const { target: row, skillMapId, trades } = useBoundContext()
    const { tradeId, skills, conditionalRuleCount } = row
    const hasSkills = skills.length > 0
    const assignments = skillMapScheduleAssignments.useResults({ skillMapId })
    const [, setViewMode] = useSearchParam("skillMapView", "skills")
    const summary = describeAssignmentCounts(countAssignmentsByKind(assignments, { trades, tradeId }))

    return (
        <If value={!!summary}>
            <Chip
                size="small"
                variant="outlined"
                color="secondary"
                icon={<Iconify icon="mdi:folder-outline" width={16} />}
                label={`${summary} assigned`}
                onClick={openAssignments}
                data-cy="trade-assignment-summary"
            />
            <Else>
                <If value={!hasSkills}>
                    <TradeNoSkillsLabel conditionalRuleCount={conditionalRuleCount} />
                </If>
            </Else>
        </If>
    )

    // The trade row opens the edit drawer on click, so keep this click to ourselves
    function openAssignments(event) {
        event.stopPropagation()
        setViewMode("assignments")
    }
}
